import React, { PureComponent } from 'react';
import { UiSection } from '../../../../enums';
import {
  ISearchResultsLocaleLookupKeys,
  LocaleKeyTree,
} from '../../../../localization';
import {
  PaginationSize,
  SearchResponseInfoContainer,
  InfoValue,
} from './styles';
import { IProps } from './interfaces';

class Info extends PureComponent<IProps> {
  private static readonly resultSizeID = `${UiSection.SearchResults}.Size`;

  private readonly localeLookupKeys: Readonly<ISearchResultsLocaleLookupKeys> = LocaleKeyTree.searchResults;

  render() {
    const { searchResponse, queryParams } = this.props;
    const size = searchResponse ? searchResponse.hits.hits.length : 0;
    const total = searchResponse ? searchResponse.hits.total.value : 0;
    const startRecord = size > 0 ? ((queryParams.page - 1) * queryParams.size) + 1 : 0;
    const endRecord = size > 0 ? ((startRecord + size) - 1) : 0;

    const formattedTotal = new Intl.NumberFormat('en-US', {
      style: 'decimal',
    }).format(total);

    return (
      <SearchResponseInfoContainer>
        <PaginationSize>
          <InfoValue id={Info.resultSizeID}>{ `${startRecord}–${endRecord} of ${formattedTotal}` }</InfoValue>
        </PaginationSize>
      </SearchResponseInfoContainer>
    );
  }
}

export default Info;
